import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';

import { PatientActions } from 'src/redux/actions/constant';
import patientService from 'src/services/apiServices/patientService';

const {
  GET_ALL_PATIENT_PRIOR_CHARGES_SUCCESS,
  GET_ALL_PATIENT_PRIOR_CHARGES_REQUEST,
  GET_ALL_PATIENT_PRIOR_CHARGES_FAILURE,
} = PatientActions;

function* getAllPatientPriorCharges(action: any): SagaReturnType<any> {
  try {
    const response = yield call(patientService.getAllPatientPriorCharges, action.patientUuid);
    if (response?.status === 200) {
      yield put({ type: GET_ALL_PATIENT_PRIOR_CHARGES_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_ALL_PATIENT_PRIOR_CHARGES_FAILURE, payload: error });
  }
}

function* getAllPatientPriorChargesSaga() {
  yield takeEvery(GET_ALL_PATIENT_PRIOR_CHARGES_REQUEST, getAllPatientPriorCharges);
}

export default getAllPatientPriorChargesSaga;
